/* JO Boutique · v3
   Los botones "Commander" llevan directo al pedido: packs y formulario, sin la foto del producto. */
(function () {
  'use strict';

  var HASH = '#commande';

  /* 1 · tarjetas de producto y botones de la portada: el enlace lleva al pedido */
  var SELECTOR = 'product-card a[href*="/products/"], .hero a[href*="/products/"], a.button-custom[href*="/products/"]';
  function tag() {
    document.querySelectorAll(SELECTOR).forEach(function (a) {
      if (a.getAttribute('href').indexOf('#') === -1) a.setAttribute('href', a.getAttribute('href') + HASH);
    });
  }
  tag();
  new MutationObserver(tag).observe(document.documentElement, { childList: true, subtree: true });

  /* 2 · ficha de producto: si llegas con #commande, la pantalla empieza en el pedido */
  function target() {
    return (
      document.querySelector('variant-picker .jo-offers') ||
      document.getElementById('es-form-container') ||
      document.querySelector('.product-details')
    );
  }
  function headerHeight() {
    var h = document.querySelector('header');
    return (h && h.offsetHeight) || 60;
  }
  function goToOrder() {
    var t = target();
    if (!t) return false;
    window.scrollTo(0, t.getBoundingClientRect().top + window.scrollY - headerHeight() - 8);
    return true;
  }
  function init() {
    if (location.hash !== HASH || !document.querySelector('.product-details')) return;
    var tries = 0;
    (function wait() {
      var ready = document.getElementById('es-form-container') || tries > 40;
      if (ready) {
        goToOrder();
        /* la página se acomoda cuando carga el formulario y las fuentes */
        setTimeout(goToOrder, 400);
        setTimeout(goToOrder, 1200);
      } else {
        tries++;
        setTimeout(wait, 250);
      }
    })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
